<ng-container *ngIf="pagename=='dynamic-card'; else elseTemplate">
  <ion-header class="header">
    <ion-toolbar>
      <ion-title class="inter-large font-size-18 color-netral-900">{{ "common_text.photo_tips_title_text" | translate
        }}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content *ngIf="!isShowExamples" class="no-scroll content custom-background">
    <div class="modeltop full-background">
      <ion-grid class="gridbackground">
        <ion-row class="customscroll">
          <ion-col size="12">
            <div style="display:flex; align-items:center; gap:8px; padding-top: 15px;">
              <!-- Back Icon -->
              <ion-icon name="chevron-back-outline" *ngIf="parentData != null" (click)="backToCard()"
                class="font-size-22"></ion-icon>
              <!-- Title -->
              <h3 *ngIf="parentData" style="margin:0; font-size:18px; font-weight:600;">
                {{parentData?.label[_appSetting.selectedLanguage] || parentData?.label}}
              </h3>

            </div>
            <p class="inter-regular font-size-18 f-w-600 color-netral-700 m-10-0">{{
              "common_text.help_guide_photo_tips_text" | translate }}
            </p>
            <ul class="inter-regular font-size-16 m-all-0 p-b-50 inner-oveflow color-netral-700"
              style="margin-left: -20px;">
              <li *ngFor="let item of customJsonForm; let i = index" [hidden]="isdisable(item)">
                <div (click)="getEvent(item)" style="
                            display:flex;
                            align-items:center;
                            justify-content:flex-start;
                            width:100%;
                            min-height:10px;
                            cursor:pointer;
                          ">
                  <u>{{item.label[_appSetting.selectedLanguage]}}</u>
                </div>
              </li>
            </ul>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-content>

  <ion-footer *ngIf="!isShowExamples" class="white-background ion-text-center b-t-1 p-2 m-b-5">
    <ion-button class="commonbtn font-size-18 inter-medium h-48 t-c letter-spacing-normal" expand="block"
      (click)="dismiss()">{{
      "common_btn_text.close_btn" | translate}}</ion-button>
  </ion-footer>


  <ion-content [hidden]="!isShowExamples" class="no-scroll content">
    <div class="modeltop full-background">
      <ion-grid class="gridbackground">
        <ion-row class="customscroll">
          <ion-col *ngIf="showImages">
            <div *ngFor="let item of showCategoryImages; let i=index">
              <div class="ion-text-center" class="max-w-100 w-100 inner-oveflow">
                <ion-row>
                  <ion-col size="12" class="p-t-0">
                    <div style="display:flex; align-items:center; gap:8px; padding-top: 15px;">
                      <!-- Back Icon -->
                      <ion-icon name="chevron-back-outline" (click)="backToCard()" class="font-size-22"></ion-icon>
                      <!-- Title -->
                      <h3 style="margin:0; font-size:18px; font-weight:600;">
                        {{item.title[_appSetting.selectedLanguage] || item.title }}
                      </h3>
                    </div>
                  </ion-col>
                </ion-row>
                <swiper-container #showexamples [options]="slideOpts" class="modal-help-example">
                  <swiper-slide *ngFor="let imgitm of helpfilteredImages; let j = index">
                    <div class="ion-text-center" class="max-w-100 w-100">
                      <ion-img [src]="imgitm.imageUrl" class="max-w-100 imgcontainer">
                      </ion-img>
                      <div class="prev-next" *ngIf="imagearraylength !=1">
                        <ion-icon (click)="swipePrev()" class="btn-prev" name="chevron-back-outline"></ion-icon>
                        <ion-icon (click)="swipeNext()" class="btn-next" name="chevron-forward-outline"></ion-icon>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper-container>
                <p class="inter-regular font-size-15 text-gray m-t-10 color-netral-700">
                  {{item.description[_appSetting.selectedLanguage] || item.description
                  || 'N\A'}}
                </p>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-content>
  <ion-footer [hidden]="!isShowExamples" class="white-background ion-text-center b-t-1 p-2 m-b-5">
    <div fxLayout="row" fxLayoutAlign="space-evenly none" class="m-l-5">
      <div fxFlex="47">
        <ion-button class="nobackground show-fulltext h-48 font-size-18 t-c inter-regular letter-spacing-normal"
          expand="block" fill="outline" (click)="dismiss()">
          {{ "common_btn_text.close_btn" | translate }}
        </ion-button>
      </div>
      <div fxFlex="47">
        <ion-button expand="block"
          class="t-c commonbtn show-fulltext h-48 font-size-18 inter-regular letter-spacing-normal"
          (click)="goToInspectionFormFill()">
          {{ "common_btn_text.take_photo_btn" | translate }}
        </ion-button>
      </div>
    </div>
  </ion-footer>
</ng-container>

<ng-template #elseTemplate>
  <ion-header class="header">
    <ion-toolbar>
      <ion-title class="inter-large font-size-18 color-netral-900">{{ "common_text.photo_tips_title_text" | translate
        }}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="no-scroll content">
    <div class="modeltop full-background">
      <ion-row class="p-5 customscroll">
        <ion-col class="p-b-10">
          <h3 class="inter-medium font-size-17 m-l-5 m-b-10  ion-text-left color-netral-800">
            {{confirmAddressHelpGuide.title[_appSetting.selectedLanguage]}}</h3>
          <swiper-container #showexamples [options]="slideOpts" class="modal-help-example tab-slides swiper-container">
            <swiper-slide *ngFor="let imgitm of helpfilteredImages; let j = index" class="slide-design swiper-slide">
              <div class="ion-text-center" class="max-w-100 w-100">
                <ion-img [src]="imgitm.imageUrl" class="max-w-100 imgcontainer">
                </ion-img>
                <div class="prev-next" *ngIf="imagearraylength !=1">
                  <ion-button (click)="swipePrev()" class="btn-prev"><ion-icon
                      name="chevron-back-outline"></ion-icon></ion-button>
                  <ion-button (click)="swipeNext()" class="btn-next"><ion-icon
                      name="chevron-forward-outline"></ion-icon></ion-button>
                </div>
              </div>
            </swiper-slide>
          </swiper-container>

          <p class="inter-regular font-size-15 text-gray m-t-10 ion-text-left color-netral-700">
            {{confirmAddressHelpGuide.description[_appSetting.selectedLanguage]}}
          </p>
        </ion-col>
      </ion-row>
      <div class="footer-modal">
        <ion-row>
          <ion-col size="6">
            <ion-button
              class="nobackground t-c inter-medium font-size-18 buttonstyle m-auto ion-text-uppercase letter-spacing-normal"
              expand="block" size="small" (click)="dismiss()"> {{ "common_btn_text.close_btn" | translate
              }}</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button
              class="commonbtn t-c inter-medium font-size-18 buttonstyle m-auto ion-text-uppercase letter-spacing-normal"
              expand="block" size="small" (click)="gototconfiemCamera()">{{
              "common_btn_text.take_photo_btn" | translate }}</ion-button>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </ion-content>
</ng-template>